require('./angular-animate');
module.exports = 'ngAnimate';



//////////////////
// WEBPACK FOOTER
// ./${exlibris_product}/npm_modules/August2022-PROD/prima/node_modules/angular-animate/index.js
// module id = 637
// module chunks = 6